const RecaptchaSubmit = {
  mounted() {
    let siteKey = this.el.dataset["siteKey"]
    let submitFormButton = this.el.dataset["submitFromButton"]
    let script = document.createElement('script')
    script.setAttribute("src", `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`)
    document.body.appendChild(script)
    this.el.addEventListener('click', () => {
      grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute(siteKey, {action: 'PERFORMER_SIGNUP'});
        this.pushEventTo(this.el, "save_recaptcha_token", {g_recaptcha: token})
      });
    })
    this.handleEvent("submit_form", () => {
      let button = document.getElementById(submitFormButton)
      button.click()
    })
  }
}

export default { RecaptchaSubmit }
